/**
 * 智慧农业云平台 - 主入口文件
 * 所属公司：河南农博联信息技术有限公司
 * 开发人员：王健
 * 提交时间：2025年
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import permission from './directive/permission'

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

// 全局主题切换指令
Vue.directive('theme', {
  bind(el, binding) {
    el.classList.add(binding.value || 'dark')
  }
})

// 权限控制指令
// 使用方法：
// v-permission="'village'" - 仅村级可见
// v-permission="'super_admin'" - 仅管理员可见
// v-permission="['admin', 'county']" - 管理员和县级可见
// v-permission="'>=town'" - 乡镇级及以上可见
Vue.directive('permission', permission)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
